var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_2497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 38.1666V35.8333H23V27.6666C23 26.0527 23.4861 24.6187 24.4583 23.3645C25.4305 22.1103 26.6944 21.2888 28.25 20.8999V18.3333H31.75V20.8999C33.3055 21.2888 34.5694 22.1103 35.5416 23.3645C36.5138 24.6187 37 26.0527 37 27.6666V35.8333H39.3333V38.1666H20.6666ZM30 41.6666C29.3583 41.6666 28.809 41.4381 28.352 40.9812C27.8951 40.5242 27.6666 39.9749 27.6666 39.3333H32.3333C32.3333 39.9749 32.1048 40.5242 31.6479 40.9812C31.1909 41.4381 30.6416 41.6666 30 41.6666ZM25.3333 35.8333H34.6666V27.6666C34.6666 26.3833 34.2097 25.2846 33.2958 24.3708C32.3819 23.4569 31.2833 22.9999 30 22.9999C28.7166 22.9999 27.618 23.4569 26.7041 24.3708C25.7902 25.2846 25.3333 26.3833 25.3333 27.6666V35.8333Z",
    fill: "#95A1C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_2497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon04);
export default __webpack_public_path__ + "static/media/leftmenu_icon04.5d21f5cc28a72055009d0882d412400b.svg";
export { ForwardRef as ReactComponent };